@if (!errorOccurred()) {
  <div id="reportContainer" class="d-flex flex-column reportContainer"></div>
} @else {
  <div class="messageAlert">
    <p>Could not load dashboard</p>
  </div>
}
